import { openAlertOkAsync } from '@pressreader/popups-alert';
import { localizedString } from '@pressreader/resources';

interface IContentNotAllowedData {
    Parameters?: {
        message?: string;
    };
}

export function contentNotAllowed(data: IContentNotAllowedData) {
    const message = data?.Parameters?.message || localizedString('ContentAccessDeniedException.ContentNotAllowed.Text');
    openAlertOkAsync({ message, isHtml: true });
    return { skipRetry: true };
}
